import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DealConfigurationQuery } from 'generated/graphql'
import { Observable, Subscription } from 'rxjs'
import { BE_CO2_FEE } from '@mistergreen/shared/constants/numbers'
import { calculateVAA_ATN } from '@mistergreen/shared/utilities/vaa-atn-co2'

@Component({
    selector: 'mg-deal-vaa-atn',
    templateUrl: './deal-vaa-atn.component.html',
    styleUrls: ['../deal-bijtelling/deal-bijtelling.component.scss'],
})
export class DealVaaAtnComponent implements OnInit, OnDestroy {
    @Input() deal$: Observable<DealConfigurationQuery['Deal']>
    protected dealSubscription: Subscription
    public VAA_ATN: string
    public co2 = BE_CO2_FEE

    constructor() {}

    ngOnInit(): void {
        this.dealSubscription = this.deal$.subscribe((deal: DealConfigurationQuery['Deal']) => {
            this.VAA_ATN = calculateVAA_ATN(deal.pricing.fiscalValue)
        })
    }
    ngOnDestroy(): void {
        this.dealSubscription.unsubscribe()
    }
}
